import { http } from './http';

// Reflète très exactement MeasurementSessionController / MeasurementSessionService côté
// sipconfection-frontend (measurement-session.service.ts) — même contrat, même backend, aucun
// endpoint créé pour cette PWA. Voir CLAUDE.md sipconfection-frontend, section « Table de mesure ».

// ---------- Confection (rôle ST) ----------

/** GET /commandes/confection : les ateliers de confection, pour le premier niveau de la liste. */
export function getSousTraitantsConfection() {
  return http.get('sous-traitants/confection');
}

/** GET /plannings/sous-traitant/{id} : les plannings ouverts d'un atelier. */
export function getPlanningsSousTraitant(sousTraitantId) {
  return http.get(`plannings/sous-traitant/${sousTraitantId}`);
}

/**
 * GET /measurement-sessions/planning/{id}/arrivages : les ENVOIS DE COUPE d'un planning + état de
 * mesure.
 *
 * ⚠️ Ce sont les livraisons de la COUPE vers l'atelier, pas les bons qu'il rend : le quota des
 * 10 % porte sur ce qu'il a reçu à travailler, et il mesure pendant qu'il le confectionne.
 * L'ancrage précédent (son bon de retour) revenait à lui demander le mètre ruban au moment où le
 * camion repart. Les lignes portent donc `livraisonVersId`, jamais `livraisonStId`.
 */
export function getArrivagesConfection(planningId) {
  return http.get(`measurement-sessions/planning/${planningId}/arrivages`);
}

/**
 * GET /measurement-sessions/planning/{id}/arrivages-heritees : les campagnes de confection
 * ancrées sur un bon du sous-traitant, saisies AVANT le changement d'ancrage.
 *
 * Liste SÉPARÉE de `getArrivagesConfection`, qui ne sert que des lots réellement mesurables :
 * mêler les deux ferait réapparaître l'ancien flux. Chaque ligne porte forcément un `sessionId`
 * — il n'y a rien à y créer, seulement à rouvrir pour terminer une saisie commencée. Vide dans la
 * quasi-totalité des cas.
 */
export function getArrivagesConfectionHeritees(planningId) {
  return http.get(`measurement-sessions/planning/${planningId}/arrivages-heritees`);
}

/**
 * POST /measurement-sessions/livraison-coupe/{id} : get-or-create sur l'ENVOI DE COUPE, idempotent.
 *
 * ⚠️ Prend un id de `LivraisonVersSousTraitant` (`arrivage.livraisonVersId`), jamais de
 * `LivraisonDepuisSousTraitant`. Les deux entités ont des id de même type : se tromper ouvrirait
 * une campagne sur un autre lot sans la moindre erreur visible.
 */
export function ouvrirSessionConfection(livraisonVersId) {
  return http.post(`measurement-sessions/livraison-coupe/${livraisonVersId}`);
}

// ---------- Délavage, réception (rôle DELAVAGE) ----------

/** GET /commandes/ok-delavage/dtos : commandes réceptionnables à l'atelier délavage. */
export function getCommandesDelavage() {
  return http.get('commandes/ok-delavage/dtos');
}

/** GET /measurement-sessions/commande/{id}/arrivages-delavage. */
export function getArrivagesDelavage(commandeId) {
  return http.get(`measurement-sessions/commande/${commandeId}/arrivages-delavage`);
}

/** POST /measurement-sessions/reception-delavage/{id} : get-or-create. */
export function ouvrirSessionDelavage(receptionDelavageId) {
  return http.post(`measurement-sessions/reception-delavage/${receptionDelavageId}`);
}

// ---------- Finition, après lavage (rôle FINITION) ----------

/** GET /commandes/okFinition : commandes en attente de finition. */
export function getCommandesFinition() {
  return http.get('commandes/okFinition');
}

/** GET /measurement-sessions/commande/{id}/arrivages : réceptions finition + état de mesure. */
export function getArrivagesFinition(commandeId) {
  return http.get(`measurement-sessions/commande/${commandeId}/arrivages`);
}

/** POST /measurement-sessions/reception/{id} : get-or-create. */
export function ouvrirSessionFinition(receptionId) {
  return http.post(`measurement-sessions/reception/${receptionId}`);
}

// ---------- Session de mesure : commun aux trois volets ----------

/**
 * Sans aucune norme ni tolérance dans la réponse — confidentialité STRUCTURELLE côté serveur,
 * pas un filtre à respecter ici. `lines[].code/label/videoUrl`, `pieces[].values[].statut`
 * ("OK"|"NOK"|null) sont la SEULE information de conformité visible depuis cette PWA.
 */
export function getSession(sessionId) {
  return http.get(`measurement-sessions/${sessionId}`);
}

/**
 * Enregistre une pièce entière en un seul appel (pas un appel par cote) : une coupure réseau ne
 * fait perdre qu'une pièce, jamais une cote isolée dans une pièce déjà comptée.
 * `piece` : { size: string, values: [{ lineId, measuredValue }] }
 */
export function ajouterPiece(sessionId, piece) {
  return http.post(`measurement-sessions/${sessionId}/pieces`, piece);
}

export function modifierPiece(sessionId, pieceId, piece) {
  return http.put(`measurement-sessions/${sessionId}/pieces/${pieceId}`, piece);
}

export function supprimerPiece(sessionId, pieceId) {
  return http.del(`measurement-sessions/${sessionId}/pieces/${pieceId}`);
}
